import { render } from "./index.vue?vue&type=template&id=9b4a1b94&scoped=true&ts=true"
import script from "./component.ts?vue&type=script&lang=ts"
export * from "./component.ts?vue&type=script&lang=ts"

import "./style.sass?vue&type=style&index=0&id=9b4a1b94&lang=sass&scoped=true"
import "./index.vue?vue&type=style&index=1&id=9b4a1b94&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4a1b94"]])

export default __exports__